import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  TouchableHighlight,
  Button,
  View,
  Alert,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import * as Clipboard from 'expo-clipboard';

import FirebaseUsers from '../firebase/firebase_users.js'
import Messaging from '../messaging.js';

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import EonnIconCheckboxes from '../components/icon_checkboxes';
import EonnLink from '../components/link';
import EonnField from '../components/field';
import PhoneField from '../components/phone_field';
import { mstyles } from '../constants/MainStyles';

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 30,
    marginBottom: 15,
    textAlign: 'center',
    color: '#333',
  },
  profileButtonWrapper: {
    marginBottom: 20,
  },
  profileButton: {
    borderRadius: 100,
  },
  profileCircle: {
    width: 150,
    height: 150,
    borderRadius: 75,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileButtonText: {
    textAlign: 'center',
    fontSize: 16,
    lineHeight: 18,
    fontFamily: 'nunito',
    color: '#fff',
    marginTop: 10,
  },
  profilePicture: {
    width: 150,
    height: 150,
    borderRadius: 75,
    alignSelf: 'center',
  },
  profileButtonShadow: {
    width: 150,
    height: 150,
    borderRadius: 75,
    backgroundColor: '#e2e0e0',
    position: 'absolute',
    top: 4,
  },
  // Phone field styles moved to PhoneField component
  successMessage: {
    color: '#606060',
    fontSize: 16,
    textAlign: 'center',
    marginTop: -25,
    marginBottom: 45,
    fontStyle: 'italic',
  },
  errorMessage: {
    color: '#f44336',
    fontSize: 16,
    textAlign: 'center',
    marginTop: -25,
    marginBottom: 45,
    fontStyle: 'italic',
  },
});

export default class Screen extends Component {

  constructor(props) {
    super(props);
    
    // Initialize state with current user data
    this.state = {
      loading: false,
      showRequired: false,
      err: "",
      emailError: false,
      pwError: false,
      
      // Profile data
      name: global.user.name || "",
      phone: global.user.phone || "",
      countryCode: global.user.countryCode || "+1",
      email: global.user.email || "",
      originalEmail: global.user.email || "", // Track original email for change detection
      businessName: global.user.businessName || "",
      rate: global.user.rate || "",
      techLink: global.user.techLink ? decodeURIComponent(global.user.techLink) : "",
      experience: global.user.experience || "",
      about: global.user.about || "",
      profilePicture: global.user.profilePicture || null,
      
      // Expertise selections
      selectedExpertise: global.user.expertise || [],
      selectedSpecializations: global.user.specializations || [],
      
      // Password change
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showPasswordSection: false,
      
      // Email change password (required for email updates)
      emailChangePassword: "",
      
      // Success/Error messages
      profileMessage: "",
      profileMessageType: "", // 'success' or 'error'
      passwordMessage: "",
      passwordMessageType: "", // 'success' or 'error'
    };

    // Extract country code from phone if it exists
    const countryCodes = [
      { code: "+1", country: "US/Canada" },
      { code: "+44", country: "UK" },
      { code: "+61", country: "Australia" },
      { code: "+91", country: "India" },
      { code: "+33", country: "France" },
      { code: "+34", country: "Spain" },
      { code: "+49", country: "Germany" },
      { code: "+52", country: "Mexico" },
      { code: "+55", country: "Brazil" },
      { code: "+81", country: "Japan" },
      { code: "+82", country: "South Korea" },
      { code: "+86", country: "China" },
      { code: "+234", country: "Nigeria" },
    ];
    
    if (this.state.phone && this.state.phone.startsWith('+')) {
      const matchedCountry = countryCodes.find(item => 
        this.state.phone.startsWith(item.code));
      
      if (matchedCountry) {
        this.state.countryCode = matchedCountry.code;
        this.state.phone = this.state.phone.substring(matchedCountry.code.length);
      }
    }
  }

  brands = [
    { icon: require('../assets/images/experience/acura.png'), icon2: require('../assets/images/experience/acura2.png'), title: 'Acura' },
    { icon: require('../assets/images/experience/alfa_romeo.png'), icon2: require('../assets/images/experience/alfa_romeo2.png'), title: 'Alfa Romeo' },
    { icon: require('../assets/images/experience/audi.png'), icon2: require('../assets/images/experience/audi2.png'), title: 'Audi' },
    { icon: require('../assets/images/experience/bentley.png'), icon2: require('../assets/images/experience/bentley2.png'), title: 'Bentley' },
    { icon: require('../assets/images/experience/bmw.png'), icon2: require('../assets/images/experience/bmw2.png'), title: 'BMW' },
    { icon: require('../assets/images/experience/bugatti.png'), icon2: require('../assets/images/experience/bugatti2.png'), title: 'Bugatti' },
    { icon: require('../assets/images/experience/buick.png'), icon2: require('../assets/images/experience/buick2.png'), title: 'Buick' },
    { icon: require('../assets/images/experience/cadillac.png'), icon2: require('../assets/images/experience/cadillac2.png'), title: 'Cadillac' },
    { icon: require('../assets/images/experience/chevrolet.png'), icon2: require('../assets/images/experience/chevrolet2.png'), title: 'Chevrolet' },
    { icon: require('../assets/images/experience/chrysler.png'), icon2: require('../assets/images/experience/chrysler2.png'), title: 'Chrysler' },
    { icon: require('../assets/images/experience/dodge.png'), icon2: require('../assets/images/experience/dodge2.png'), title: 'Dodge' },
    { icon: require('../assets/images/experience/ferrari.png'), icon2: require('../assets/images/experience/ferrari2.png'), title: 'Ferrari' },
    { icon: require('../assets/images/experience/fiat.png'), icon2: require('../assets/images/experience/fiat2.png'), title: 'Fiat' },
    { icon: require('../assets/images/experience/ford.png'), icon2: require('../assets/images/experience/ford2.png'), title: 'Ford' },
    { icon: require('../assets/images/experience/genesis.png'), icon2: require('../assets/images/experience/genesis2.png'), title: 'Genesis' },
    { icon: require('../assets/images/experience/gmc.png'), icon2: require('../assets/images/experience/gmc2.png'), title: 'GMC' },
    { icon: require('../assets/images/experience/honda.png'), icon2: require('../assets/images/experience/honda2.png'), title: 'Honda' },
    { icon: require('../assets/images/experience/hyundai.png'), icon2: require('../assets/images/experience/hyundai2.png'), title: 'Hyundai' },
    { icon: require('../assets/images/experience/infiniti.png'), icon2: require('../assets/images/experience/infiniti2.png'), title: 'Infiniti' },
    { icon: require('../assets/images/experience/jaguar.png'), icon2: require('../assets/images/experience/jaguar2.png'), title: 'Jaguar' },
    { icon: require('../assets/images/experience/jeep.png'), icon2: require('../assets/images/experience/jeep2.png'), title: 'Jeep' },
    { icon: require('../assets/images/experience/kia.png'), icon2: require('../assets/images/experience/kia2.png'), title: 'Kia' },
    { icon: require('../assets/images/experience/lamborghini.png'), icon2: require('../assets/images/experience/lamborghini2.png'), title: 'Lamborghini' },
    { icon: require('../assets/images/experience/land_rover.png'), icon2: require('../assets/images/experience/land_rover2.png'), title: 'Land Rover' },
    { icon: require('../assets/images/experience/lexus.png'), icon2: require('../assets/images/experience/lexus2.png'), title: 'Lexus' },
    { icon: require('../assets/images/experience/lincoln.png'), icon2: require('../assets/images/experience/lincoln2.png'), title: 'Lincoln' },
    { icon: require('../assets/images/experience/lotus.png'), icon2: require('../assets/images/experience/lotus2.png'), title: 'Lotus' },
    { icon: require('../assets/images/experience/maserati.png'), icon2: require('../assets/images/experience/maserati2.png'), title: 'Maserati' },
    { icon: require('../assets/images/experience/mazda.png'), icon2: require('../assets/images/experience/mazda2.png'), title: 'Mazda' },
    { icon: require('../assets/images/experience/mercedes_benz.png'), icon2: require('../assets/images/experience/mercedes_benz2.png'), title: 'Mercedes-Benz' },
    { icon: require('../assets/images/experience/mini.png'), icon2: require('../assets/images/experience/mini2.png'), title: 'Mini' },
    { icon: require('../assets/images/experience/mitsubishi.png'), icon2: require('../assets/images/experience/mitsubishi2.png'), title: 'Mitsubishi' },
    { icon: require('../assets/images/experience/nissan.png'), icon2: require('../assets/images/experience/nissan2.png'), title: 'Nissan' },
    { icon: require('../assets/images/experience/porsche.png'), icon2: require('../assets/images/experience/porsche2.png'), title: 'Porsche' },
    { icon: require('../assets/images/experience/ram.png'), icon2: require('../assets/images/experience/ram2.png'), title: 'Ram' },
    { icon: require('../assets/images/experience/rolls_royce.png'), icon2: require('../assets/images/experience/rolls_royce2.png'), title: 'Rolls-Royce' },
    { icon: require('../assets/images/experience/subaru.png'), icon2: require('../assets/images/experience/subaru2.png'), title: 'Subaru' },
    { icon: require('../assets/images/experience/tesla.png'), icon2: require('../assets/images/experience/tesla2.png'), title: 'Tesla' },
    { icon: require('../assets/images/experience/toyota.png'), icon2: require('../assets/images/experience/toyota2.png'), title: 'Toyota' },
    { icon: require('../assets/images/experience/volkswagen.png'), icon2: require('../assets/images/experience/volkswagen2.png'), title: 'Volkswagen' },
    { icon: require('../assets/images/experience/volvo.png'), icon2: require('../assets/images/experience/volvo2.png'), title: 'Volvo' }
  ];

  specializations = [
    { icon: require('../assets/images/specializations/ac1.png'), icon2: require('../assets/images/specializations/ac1b.png'), title: 'AC' },
    { icon: require('../assets/images/specializations/brakes1.png'), icon2: require('../assets/images/specializations/brakes1b.png'), title: 'Brake' },
    { icon: require('../assets/images/specializations/fuel1.png'), icon2: require('../assets/images/specializations/fuel1b.png'), title: 'Fuel' },
    { icon: require('../assets/images/specializations/electronics1.png'), icon2: require('../assets/images/specializations/electronics1b.png'), title: 'Electronics' },
    { icon: require('../assets/images/specializations/electrical1.png'), icon2: require('../assets/images/specializations/electrical1b.png'), title: 'Electrical' },
    { icon: require('../assets/images/specializations/engine1.png'), icon2: require('../assets/images/specializations/engine1b.png'), title: 'Engine' },
    { icon: require('../assets/images/specializations/steering1.png'), icon2: require('../assets/images/specializations/steering1b.png'), title: 'Steering' },
    { icon: require('../assets/images/specializations/suspension1.png'), icon2: require('../assets/images/specializations/suspension1b.png'), title: 'Suspension' },
    { icon: require('../assets/images/specializations/transmission1.png'), icon2: require('../assets/images/specializations/transmission1b.png'), title: 'Transmission' },
  ];

  onSelectProfilePicture = async () => {
    try {
      const localUri = await FirebaseUsers.pickImage();
      console.log('Image selected successfully:', localUri);
      this.setState({ 
        profilePicture: localUri,
        profileMessage: "", 
        profileMessageType: "" 
      });
    } catch (error) {
      console.log('Error:', error.message);
    }
  }

  copyCustomUrl = async () => {
    try {
      const baseUrl = 'https://consult.autoteletech.com/';
      const slug = (this.state.techLink || '').trim();
      const encodedSlug = encodeURIComponent(slug);
      const fullUrl = baseUrl + encodedSlug;
      await Clipboard.setStringAsync(fullUrl);
      Alert.alert('Copied', 'URL copied to clipboard');
    } catch (error) {
      Alert.alert('Error', 'Failed to copy URL');
    }
  }

  saveProfile = async () => {
    this.setState({ 
      loading: true, 
      err: "", 
      profileMessage: "", 
      profileMessageType: "" 
    });

    try {
      // Validate required fields
      if (!this.state.name || !this.state.phone || !this.state.email || !this.state.rate || !this.state.techLink || !this.state.experience) {
        this.setState({ 
          err: "Please fill in all required fields",
          loading: false,
          showRequired: true 
        });
        return;
      }

      // Validate consultation rate minimum
      const rate = parseFloat(this.state.rate);
      if (isNaN(rate) || rate < 10) {
        this.setState({ 
          err: "Price per consultation must be at least $10.00",
          loading: false,
          profileMessage: "Minimum rate requirement not met",
          profileMessageType: "error"
        });
        return;
      }

      // Check if email has changed and require password for email change
      const emailChanged = this.state.email !== this.state.originalEmail;
      if (emailChanged && !this.state.emailChangePassword) {
        this.setState({ 
          err: "Please enter your current password to change your email address",
          loading: false,
          profileMessage: "Password required for email change",
          profileMessageType: "error"
        });
        return;
      }

      // Validate email format
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(this.state.email)) {
        this.setState({ 
          err: "Please enter a valid email address",
          loading: false,
          emailError: true 
        });
        return;
      }

      // Validate phone number
      const cleanPhone = this.state.phone.replace(/[\s()-\.]/g, '');
      if (!/^[0-9]{6,12}$/.test(cleanPhone)) {
        this.setState({ 
          err: "Please enter a valid phone number without the country code",
          loading: false 
        });
        return;
      }

      // Handle email change if needed
      if (emailChanged) {
        await FirebaseUsers.changeEmail(this.state.email, this.state.emailChangePassword);
      }

      // Upload profile picture if changed
      let profilePictureUrl = this.state.profilePicture;
      if (this.state.profilePicture && !this.state.profilePicture.startsWith('http')) {
        profilePictureUrl = await FirebaseUsers.uploadProfilePicture(this.state.profilePicture);
      }

      // Update global user object
      global.user = {
        ...global.user,
        name: this.state.name,
        phone: this.state.countryCode + cleanPhone,
        countryCode: this.state.countryCode,
        email: this.state.email,
        businessName: this.state.businessName,
        rate: this.state.rate,
        techLink: encodeURIComponent(this.state.techLink),
        experience: this.state.experience,
        about: this.state.about,
        profilePicture: profilePictureUrl,
        expertise: this.state.selectedExpertise,
        specializations: this.state.selectedSpecializations,
      };

      // Save to Firebase
      await FirebaseUsers.updateUserInfo();

      this.setState({ 
        loading: false,
        profileMessage: "Profile updated successfully!",
        profileMessageType: "success",
        originalEmail: this.state.email, // Update original email after successful save
        emailChangePassword: "" // Clear password field after successful save
      });

    } catch (error) {
      console.log('Error saving profile:', error);
      
      let errorMessage = "Error saving profile. Please try again.";
      
      // Handle specific email change errors
      if (error.code === 'auth/wrong-password') {
        errorMessage = "Incorrect password. Please try again.";
      } else if (error.code === 'auth/email-already-in-use') {
        errorMessage = "This email address is already in use by another account.";
      } else if (error.code === 'auth/invalid-email') {
        errorMessage = "Please enter a valid email address.";
      }
      
      this.setState({ 
        loading: false,
        profileMessage: errorMessage,
        profileMessageType: "error"
      });
    }
  }

  changePassword = async () => {
    if (!this.state.currentPassword || !this.state.newPassword || !this.state.confirmPassword) {
      this.setState({ 
        passwordMessage: "Please fill in all password fields",
        passwordMessageType: "error"
      });
      return;
    }

    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({ 
        passwordMessage: "New passwords don't match",
        passwordMessageType: "error"
      });
      return;
    }

    this.setState({ 
      loading: true, 
      passwordMessage: "", 
      passwordMessageType: "" 
    });

    try {
      await FirebaseUsers.changePassword(this.state.currentPassword, this.state.newPassword);
      
      this.setState({ 
        loading: false,
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordMessage: "Password changed successfully!",
        passwordMessageType: "success"
      });

    } catch (error) {
      let errorText = "";
      switch (error.code) {
        case 'auth/wrong-password':
          errorText = "Incorrect current password";
          break;
        case 'auth/weak-password':
          errorText = "New password must be at least 6 characters long";
          break;
        default:
          errorText = "Error changing password";
      }
      
      this.setState({ 
        loading: false,
        passwordMessage: errorText,
        passwordMessageType: "error"
      });
    }
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <EonnTitle>My Account</EonnTitle>

        {/* Profile Picture Section */}
        <Text style={styles.sectionTitle}>Profile Picture</Text>
        <View style={styles.profileButtonWrapper}>
          <View style={styles.profileButtonShadow}></View>
          <TouchableHighlight
            style={styles.profileButton}
            underlayColor={'rgba(0, 0, 0, 0.2)'}
            onPress={this.onSelectProfilePicture}
          >
            {this.state.profilePicture ? (
              <Image
                source={{ uri: this.state.profilePicture }}
                style={styles.profilePicture}
              />
            ) : (
              <LinearGradient
                colors={['#ed3d2a', '#d13025']}
                style={styles.profileCircle}
                start={[0, 0.5]}
                end={[1, 0.5]}
              >
                <Text style={styles.profileButtonText}>Select a profile photo</Text>
              </LinearGradient>
            )}
          </TouchableHighlight>
        </View>

        {/* Custom Link */}
        <Text style={styles.sectionTitle}>Custom Link</Text>
        <Text style={[mstyles.text, mstyles.smallText]}>
          When customers visit this link, they'll be able to see your profile and request video consultations from you directly.  Click the button below to copy the link, then share it with your customers to get more bookings.
        </Text>
        <EonnField
          onChange={value => this.setState({ 
            techLink: value,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          showRequired={this.state.showRequired}
          value={this.state.techLink}
          helpText="https://consult.autoteletech.com/"
        >
        </EonnField>

        <EonnButton
          style={{ marginTop: 10, marginBottom: 30, width: 220 }}
          onPress={this.copyCustomUrl}
          small
        >
          Copy link
        </EonnButton>


        {/* Basic Information */}
        <Text style={styles.sectionTitle}>Basic Information</Text>
        
        <EonnField
          onChange={value => this.setState({ 
            name: value, 
            profileMessage: "", 
            profileMessageType: "" 
          })}
          showRequired={this.state.showRequired}
          value={this.state.name}
        >
          Name
        </EonnField>

        <PhoneField
          phoneValue={this.state.phone}
          countryCode={this.state.countryCode}
          onPhoneChange={value => this.setState({ 
            phone: value, 
            profileMessage: "", 
            profileMessageType: "" 
          })}
          onCountryCodeChange={value => this.setState({ 
            countryCode: value,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          showRequired={this.state.showRequired}
          countryCodes={[
            { code: "+1", country: "US/Canada" },
            { code: "+44", country: "UK" },
            { code: "+61", country: "Australia" },
            { code: "+91", country: "India" },
            { code: "+33", country: "France" },
            { code: "+34", country: "Spain" },
            { code: "+49", country: "Germany" },
            { code: "+52", country: "Mexico" },
            { code: "+55", country: "Brazil" },
            { code: "+81", country: "Japan" },
            { code: "+82", country: "South Korea" },
            { code: "+86", country: "China" },
            { code: "+234", country: "Nigeria" },
          ]}
        >
          Phone Number
        </PhoneField>

        <EonnField
          onChange={value => this.setState({ 
            email: value, 
            emailError: false,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          showRequired={this.state.showRequired}
          showError={this.state.emailError}
          value={this.state.email}
          textContentType={"emailAddress"}
          autoComplete={"email"}
          inputMode={"email"}
          keyboardType={"email-address"}
        >
          Email
        </EonnField>

        {/* Business Information */}
        <Text style={styles.sectionTitle}>Business Information</Text>
        
        <EonnField
          onChange={value => this.setState({ 
            businessName: value,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          value={this.state.businessName}
        >
          Business Name
        </EonnField>

        <EonnField
          onChange={value => this.setState({ 
            rate: value,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          showRequired={this.state.showRequired}
          value={this.state.rate}
        >
          Price Per Consultation (USD)
        </EonnField>
        <Text style={[mstyles.text, mstyles.smallText, { marginTop: 5 }]}>
          Note that the minimum rate you can charge is $10, and a 25% service fee applies. We recommend starting at $20 and adjusting as you build reviews, but you can set any fair price for your time and expertise.
        </Text>

        <EonnField
          onChange={value => this.setState({ 
            experience: value,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          showRequired={this.state.showRequired}
          value={this.state.experience}
        >
          Years in the business
        </EonnField>

        <EonnField
          onChange={value => this.setState({ 
            about: value,
            profileMessage: "", 
            profileMessageType: "" 
          })}
          value={this.state.about}
          lines={10}
        >
          About you
        </EonnField>

        {/* Vehicle Expertise */}
        <Text style={styles.sectionTitle}>Vehicle Expertise</Text>
        <Text style={[mstyles.text, { maxWidth: 500, textAlign: 'center', paddingRight: 30, paddingLeft: 30 }]}>
          Select the vehicle makes you're most experienced with
        </Text>
        <EonnIconCheckboxes
          options={this.brands}
          selected={this.state.selectedExpertise}
          setSelected={selected => this.setState({ 
            selectedExpertise: selected,
            profileMessage: "", 
            profileMessageType: "" 
          })}
        />

        {/* Repair Specializations */}
        <Text style={styles.sectionTitle}>Repair Specializations</Text>
        <Text style={[mstyles.text, { maxWidth: 500, textAlign: 'center', paddingRight: 30, paddingLeft: 30 }]}>
          Select the types of repair you specialize in
        </Text>
        <EonnIconCheckboxes
          options={this.specializations}
          selected={this.state.selectedSpecializations}
          setSelected={selected => this.setState({ 
            selectedSpecializations: selected,
            profileMessage: "", 
            profileMessageType: "" 
          })}
        />

        

        {/* Show password field when email has changed */}
        {this.state.email !== this.state.originalEmail && (
          <View style={{marginTop:10, alignItems:"center", justifyContent:"center"}}>
            <Text style={[mstyles.text, { fontSize: 14, color: '#666', marginTop: 10, marginBottom: 5, textAlign: 'center' }]}>
              Password required to change email address
            </Text>
            <EonnField
              onChange={value => this.setState({ 
                emailChangePassword: value,
                profileMessage: "", 
                profileMessageType: "" 
              })}
              value={this.state.emailChangePassword}
              textContentType={"password"}
              secureTextEntry={true}
              placeholder="Enter current password"
            >
              Current Password
            </EonnField>
          </View>
        )}

        {this.state.err ? (
          <Text style={[mstyles.err, {marginTop:40, marginBottom:0}]}>{this.state.err}</Text>
        ) : null}

        {/* Save Profile Button */}
        <EonnButton
          loading={this.state.loading}
          onPress={this.saveProfile}
        >
          Save Profile
        </EonnButton>

        {/* Profile Save Message */}
        {this.state.profileMessage ? (
          <Text style={this.state.profileMessageType === 'success' ? styles.successMessage : styles.errorMessage}>
            {this.state.profileMessage}
          </Text>
        ) : null}

        {/* Password Change Section */}        
        <EonnLink onPress={() => this.setState({ showPasswordSection: !this.state.showPasswordSection })}>
          {this.state.showPasswordSection ? "Hide Password Section" : "Change Password"}
        </EonnLink>

        {this.state.showPasswordSection && (
          <View style={{marginTop:10, alignItems:"center", justifyContent:"center"}}>
            <EonnField
              onChange={value => this.setState({ 
                currentPassword: value, 
                passwordMessage: "", 
                passwordMessageType: "" 
              })}
              value={this.state.currentPassword}
              textContentType={"password"}
              secureTextEntry={true}
            >
              Current Password
            </EonnField>

            <EonnField
              onChange={value => this.setState({ 
                newPassword: value, 
                passwordMessage: "", 
                passwordMessageType: "" 
              })}
              value={this.state.newPassword}
              textContentType={"password"}
              secureTextEntry={true}
            >
              New Password
            </EonnField>

            <EonnField
              onChange={value => this.setState({ 
                confirmPassword: value, 
                passwordMessage: "", 
                passwordMessageType: "" 
              })}
              value={this.state.confirmPassword}
              textContentType={"password"}
              secureTextEntry={true}
            >
              Confirm New Password
            </EonnField>

            <EonnButton
              loading={this.state.loading}
              onPress={this.changePassword}
            >
              Update Password
            </EonnButton>

            {/* Password Change Message */}
            {this.state.passwordMessage ? (
              <Text style={this.state.passwordMessageType === 'success' ? styles.successMessage : styles.errorMessage}>
                {this.state.passwordMessage}
              </Text>
            ) : null}
          </View>
        )}

      </ScrollView>
    );
  }
} 